import { queryOptions, useQuery } from '@tanstack/react-query';
import { fetchAdminAudits } from '@/api/(admin)/audits';
import type { AdminAudit } from '@/api/(admin)/audits/types';
import type { AuditsQueryInput } from '../-types';
import { buildAuditsQs, toAuditsParams } from '../-utils/listParams';

/** Prefix for every admin-audits cache entry. */
export const adminAuditsQueryKey = ['admin', 'audits'] as const;

/** Shared by the route loader and the page, so the prefetch warms what it reads. */
export function adminAuditsQueryOptions(input: AuditsQueryInput) {
  const params = toAuditsParams(input);
  return queryOptions({
    queryKey: [...adminAuditsQueryKey, 'list', params] as const,
    queryFn: () => fetchAdminAudits(buildAuditsQs(params)),
  });
}

export function useAdminAudits(input: AuditsQueryInput) {
  const query = useQuery(adminAuditsQueryOptions(input));
  const rows: AdminAudit[] = query.data?.data ?? [];
  return { ...query, rows, totalCount: query.data?.meta?.totalCount ?? 0 };
}
